// ═══════════════════════════════════════
// I18N — Traductions côté client
//
// Lit window.__LANG__ (injecté par partition.php).
// Expose t(key, params) et lang().
//
// Interpolation : {variable} dans les chaînes.
// Pluriel : clés suffixées .plural (n > 1).
// ═══════════════════════════════════════

const _translations = {

    fr: {
        // ── Auth ─────────────────────────────────────────────────────────────
        'auth.error.network'            : 'Erreur de connexion',
        'auth.error.passwords_mismatch' : 'Les mots de passe ne correspondent pas.',
        'auth.error.password_short'     : 'Mot de passe trop court (min 6 caractères).',
        'auth.account_deleted'          : 'Compte supprimé.',
        'auth.forgot_sent'              : 'Email envoyé si le compte existe.',
        'auth.reset_success'            : '✓ Mot de passe mis à jour. Vous pouvez vous connecter.',
        'auth.error.invalid_link'       : 'Lien invalide ou expiré.',
        'auth.error.update_failed'      : 'Erreur lors de la mise à jour.',
        'auth.btn_account'              : 'Mon compte',
        'auth.btn_login'                : 'Se connecter',

        // ── Navigation / save status ─────────────────────────────────────────
        'nav.save_ok'                   : '✓ Enregistré',
        'nav.save_error_title'          : 'Ajoutez un titre T: dans la partition',
        'nav.save_error_server'         : 'Erreur serveur',
        'nav.save_error_network'        : 'Erreur réseau',
        'nav.error_unknown'             : 'Erreur inconnue',
        'nav.access_denied_title'       : 'Accès refusé',
        'nav.access_denied_msg'         : 'Vous n\'avez pas accès à cette partition.',
        'nav.access_denied_btn'         : '← Retour aux partitions',
        'nav.delete_confirm'            : 'Supprimer définitivement « {title} » ?\nCette action est irréversible.',
        'nav.delete_error'              : 'Erreur : {error}',
        'nav.toggle_error'              : 'Erreur : {error}',
        'nav.autosave_saving'           : '⏳ Sauvegarde auto…',
        'nav.autosave_ok'               : '✓ Sauvegardé automatiquement',

        // ── Groups ───────────────────────────────────────────────────────────
        'groups.loading'                : 'Chargement…',
        'groups.empty'                  : 'Aucun groupe.',
        'groups.error_load'             : 'Erreur de chargement.',
        'groups.error_network'          : 'Erreur de connexion',
        'groups.member_count'           : '{n} membre',
        'groups.member_count.plural'    : '{n} membres',
        'groups.modal_create_title'     : '✏️ Nouveau groupe',
        'groups.modal_edit_title'       : '✏️ Modifier le groupe',
        'groups.error_name_required'    : 'Le nom est obligatoire.',
        'groups.delete_confirm'         : 'Supprimer ce groupe définitivement ?',
        'groups.no_groups_msg'          : 'Vous n\'avez aucun groupe. Créez-en un depuis « Mes groupes ».',
        'groups.badge_delegate'         : 'Penn pupitre',
        'groups.delegates_title'        : 'Penn pupitres ({n}/{max} pour cet ensemble)',
        'groups.delegates_none'         : 'Aucun penn pupitre.',
        'groups.delegates_hint'         : 'Un penn pupitre gère les membres et les rubriques du groupe et bénéficie d\'un accès Solo offert. Il ne peut pas supprimer le groupe.',
        'groups.delegate_placeholder'   : 'Adresse du compte du penn pupitre',
        'groups.delegate_add'           : 'Ajouter',
        'groups.delegate_remove'        : 'Retirer',
        'groups.delegate_leave'         : 'Quitter la fonction',
        'groups.delegate_remove_confirm': 'Retirer {name} des penn pupitres ? Il reste membre du groupe.',
        'groups.delegate_leave_confirm' : 'Quitter votre fonction de penn pupitre ? Vous restez membre du groupe.',
        'groups.cede_label'             : 'Céder cette partition à l\'ensemble',
        'groups.cede_confirm'           : 'Céder « {title} » à l\'ensemble « {group} » ?\n\nLa partition lui appartiendra définitivement. Vous pourrez toujours l\'éditer tant que vous êtes penn pupitre de ce groupe, mais plus la supprimer ni la retirer du groupe.',

        // ── Share ────────────────────────────────────────────────────────────
        'share.error_login'             : 'Connectez-vous pour envoyer des emails.',
        'share.error_no_recipient'      : 'Ajoutez au moins un email ou sélectionnez un groupe.',
        'share.status_generating'       : '⏳ Génération du PDF…',
        'share.status_sending'          : '⏳ Envoi en cours…',
        'share.status_sent'             : '✅ Envoyé à : {recipients}',
        'share.status_failed'           : '⚠️ Échec d\'envoi pour : {recipients}',
        'share.error_no_valid'          : 'Aucun destinataire valide.',
        'share.error_network'           : 'Erreur réseau.',

        // ── Attachments ──────────────────────────────────────────────────────
        'attach.error_score_size'       : 'Le fichier score dépasse la limite de {max} Mo.',
        'attach.error_audio_size'       : 'Le fichier audio dépasse la limite de {max} Mo.',

        // ── Header form / modales éditeur ────────────────────────────────────
        'hf.voice_label'                : 'Voix {n}',
        'hf.modal_params_edit'          : '⚙️ Paramètres',
        'hf.modal_params_new'           : '✨ Nouvelle partition',
        'hf.modal_voice_new'            : '✨ Nouvelle voix',
        'hf.modal_voice_edit'           : '⚙️ Voix {n}',
        'hf.error_title_required'       : 'Le titre est obligatoire.',
        'hf.error_network'              : 'Erreur réseau, veuillez réessayer.',
        'hf.next_btn_searching'         : 'Recherche…',
        'hf.next_btn_label'             : 'Étape suivante →',
        'hf.new_btn_creating'           : 'Création…',
        'hf.new_tune_btn'               : 'Créer un nouveau morceau',
        'hf.error_tune_attach'          : 'Erreur lors du rattachement.',
        'hf.error_tune_create'          : 'Erreur lors de la création.',
        'hf.voice_delete_confirm'       : 'Supprimer la voix {n} ? Cette action est irréversible.',
        'hf.voice_hide'                 : 'Masquer cette voix',
        'hf.voice_show'                 : 'Afficher cette voix',
        'hf.voice_hide_last'            : 'Impossible de cacher la dernière voix visible',
        'hf.upgrade_msg'                : 'Vous avez atteint la limite de {limit} partition{limit_s} de votre abonnement actuel ({count} créée{count_s}).',

        // ── Pagination / filtres (common/main.js) ────────────────────────────
        'list.count'                    : '{n} partition',
        'list.count.plural'             : '{n} partitions',
        'list.pagin_prev'               : '‹ Précédent',
        'list.pagin_next'               : 'Suivant ›',
        'list.pagin_info'               : '{from}–{to} sur {total}',
        'list.filters_btn'              : '🔍 Filtres',
        'list.filters_apply'            : 'Afficher les résultats',
        'list.filters_title'            : 'Filtres',

        // ── Suppression de compte (assistant) ────────────────────────────────
        'del.loading'                   : 'Chargement…',
        'del.error_load'                : 'Impossible de préparer la suppression. Réessayez dans un instant.',
        'del.error_generic'             : 'La suppression a échoué.',
        'del.step'                      : 'Étape {n} sur {total}',
        'del.submitting'                : 'Suppression…',
        'del.btn_confirm'               : 'Supprimer définitivement',

        'del.sum.partitions'            : '{n} partition',
        'del.sum.partitions.plural'     : '{n} partitions',
        'del.sum.public'                : '{n} publique',
        'del.sum.public.plural'         : '{n} publiques',
        'del.sum.private'               : '{n} privée',
        'del.sum.private.plural'        : '{n} privées',
        'del.sum.groups'                : '{n} groupe',
        'del.sum.groups.plural'         : '{n} groupes',
        'del.sum.subscription'          : 'Abonnement {plan} en cours',
        'del.sum.engagement'            : 'engagement jusqu\'au {date}',
        'del.sum.none'                  : 'Rien à décider : ce compte ne laisse ni partition ni groupe.',

        'del.part.lead'                 : 'Vous avez {n} partition(s) : {pub} publique(s) et {priv} privée(s).',

        'del.group.lead'                : '« {name} » — groupe {i} sur {total}, {n} personne(s) servie(s).',
        'del.group.choose'              : 'Choisir un membre…',
        'del.ensemble'                  : 'offre Ensemble',
        'del.no_ensemble'               : 'sans offre Ensemble',

        'del.sub.lead'                  : 'Votre abonnement {plan} est en cours.',
        'del.sub.engagement'            : 'Votre engagement court jusqu\'au {date}.',

        'del.err.choice'                : 'Choisissez une option pour continuer.',
        'del.err.email'                 : 'Indiquez l\'adresse du compte destinataire.',
        'del.err.fallback'              : 'Indiquez ce qui doit arriver si la proposition est refusée.',
        'del.err.heir'                  : 'Choisissez le membre à qui confier le groupe.',
        'del.err.ack'                   : 'Cochez la case pour continuer.',
        'del.err.password'              : 'Saisissez votre mot de passe.',

        'del.recap.partitions.keep_public' : 'Partitions : les publiques restent en ligne, les privées sont supprimées.',
        'del.recap.partitions.bequeath'    : 'Partitions : proposées à {email}.',
        'del.recap.partitions.delete'      : 'Partitions : toutes supprimées, fichiers compris.',
        'del.recap.fallback.keep_public'   : 'En cas de refus : les publiques restent en ligne, les privées sont supprimées.',
        'del.recap.fallback.delete'        : 'En cas de refus : tout est supprimé.',
        'del.recap.group.bequeath'         : '{group} : proposé à {name}.',
        'del.recap.group.delete'           : '{group} : supprimé.',
        'del.recap.groups_empty'           : '{n} groupe sans membre : supprimé.',
        'del.recap.groups_empty.plural'    : '{n} groupes sans membre : supprimés.',
        'del.recap.subscription'           : 'Abonnement : annulé immédiatement, sans remboursement.',
        'del.recap.reason'                 : 'Motif : {reason}',
        'del.recap.no_reason'              : 'Motif : non indiqué.',
    },

    en: {
        // ── Auth ─────────────────────────────────────────────────────────────
        'auth.error.network'            : 'Connection error',
        'auth.error.passwords_mismatch' : 'Passwords do not match.',
        'auth.error.password_short'     : 'Password too short (min 6 characters).',
        'auth.account_deleted'          : 'Account deleted.',
        'auth.forgot_sent'              : 'Email sent if the account exists.',
        'auth.reset_success'            : '✓ Password updated. You can now log in.',
        'auth.error.invalid_link'       : 'Invalid or expired link.',
        'auth.error.update_failed'      : 'Error while updating.',
        'auth.btn_account'              : 'My account',
        'auth.btn_login'                : 'Log in',

        // ── Navigation / save status ─────────────────────────────────────────
        'nav.save_ok'                   : '✓ Saved',
        'nav.save_error_title'          : 'Add a title T: to the score',
        'nav.save_error_server'         : 'Server error',
        'nav.save_error_network'        : 'Network error',
        'nav.error_unknown'             : 'Unknown error',
        'nav.access_denied_title'       : 'Access denied',
        'nav.access_denied_msg'         : 'You do not have access to this score.',
        'nav.access_denied_btn'         : '← Back to tunes',
        'nav.delete_confirm'            : 'Permanently delete "{title}"?\nThis action cannot be undone.',
        'nav.delete_error'              : 'Error: {error}',
        'nav.toggle_error'              : 'Error: {error}',
        'nav.autosave_saving'           : '⏳ Auto-saving…',
        'nav.autosave_ok'               : '✓ Auto-saved',

        // ── Groups ───────────────────────────────────────────────────────────
        'groups.loading'                : 'Loading…',
        'groups.empty'                  : 'No groups.',
        'groups.error_load'             : 'Loading error.',
        'groups.error_network'          : 'Connection error',
        'groups.member_count'           : '{n} member',
        'groups.member_count.plural'    : '{n} members',
        'groups.modal_create_title'     : '✏️ New group',
        'groups.modal_edit_title'       : '✏️ Edit group',
        'groups.error_name_required'    : 'Name is required.',
        'groups.delete_confirm'         : 'Permanently delete this group?',
        'groups.no_groups_msg'          : 'You have no groups. Create one from "My groups".',
        'groups.badge_delegate'         : 'Section leader',
        'groups.delegates_title'        : 'Section leaders ({n}/{max} for this ensemble)',
        'groups.delegates_none'         : 'No section leader.',
        'groups.delegates_hint'         : 'A section leader manages the group\'s members and sections and gets a free Solo access. They cannot delete the group.',
        'groups.delegate_placeholder'   : 'Email of the section leader\'s account',
        'groups.delegate_add'           : 'Add',
        'groups.delegate_remove'        : 'Remove',
        'groups.delegate_leave'         : 'Step down',
        'groups.delegate_remove_confirm': 'Remove {name} from section leaders? They stay a member of the group.',
        'groups.delegate_leave_confirm' : 'Step down as section leader? You stay a member of the group.',
        'groups.cede_label'             : 'Transfer this score to the ensemble',
        'groups.cede_confirm'           : 'Transfer "{title}" to the ensemble "{group}"?\n\nThe score will belong to it for good. You can still edit it while you are a section leader of this group, but no longer delete it or remove it from the group.',

        // ── Share ────────────────────────────────────────────────────────────
        'share.error_login'             : 'Log in to send emails.',
        'share.error_no_recipient'      : 'Add at least one email or select a group.',
        'share.status_generating'       : '⏳ Generating PDF…',
        'share.status_sending'          : '⏳ Sending…',
        'share.status_sent'             : '✅ Sent to: {recipients}',
        'share.status_failed'           : '⚠️ Failed to send to: {recipients}',
        'share.error_no_valid'          : 'No valid recipient.',
        'share.error_network'           : 'Network error.',

        // ── Attachments ──────────────────────────────────────────────────────
        'attach.error_score_size'       : 'Score file exceeds the {max} MB limit.',
        'attach.error_audio_size'       : 'Audio file exceeds the {max} MB limit.',

        // ── Header form / modales éditeur ────────────────────────────────────
        'hf.voice_label'                : 'Voice {n}',
        'hf.modal_params_edit'          : '⚙️ Settings',
        'hf.modal_params_new'           : '✨ New score',
        'hf.modal_voice_new'            : '✨ New voice',
        'hf.modal_voice_edit'           : '⚙️ Voice {n}',
        'hf.error_title_required'       : 'Title is required.',
        'hf.error_network'              : 'Network error, please try again.',
        'hf.next_btn_searching'         : 'Searching…',
        'hf.next_btn_label'             : 'Next step →',
        'hf.new_btn_creating'           : 'Creating…',
        'hf.new_tune_btn'               : 'Create a new tune',
        'hf.error_tune_attach'          : 'Error while linking tune.',
        'hf.error_tune_create'          : 'Error while creating tune.',
        'hf.voice_delete_confirm'       : 'Delete voice {n}? This action cannot be undone.',
        'hf.voice_hide'                 : 'Hide this voice',
        'hf.voice_show'                 : 'Show this voice',
        'hf.voice_hide_last'            : 'Cannot hide the last visible voice',
        'hf.upgrade_msg'                : 'You have reached the limit of {limit} score{limit_s} on your current plan ({count} created).',

        // ── Pagination / filtres (common/main.js) ────────────────────────────
        'list.count'                    : '{n} tune',
        'list.count.plural'             : '{n} tunes',
        'list.pagin_prev'               : '‹ Previous',
        'list.pagin_next'               : 'Next ›',
        'list.pagin_info'               : '{from}–{to} of {total}',
        'list.filters_btn'              : '🔍 Filters',
        'list.filters_apply'            : 'Show results',
        'list.filters_title'            : 'Filters',

        // ── Account deletion (wizard) ────────────────────────────────────────
        'del.loading'                   : 'Loading…',
        'del.error_load'                : 'Could not prepare the deletion. Try again in a moment.',
        'del.error_generic'             : 'Deletion failed.',
        'del.step'                      : 'Step {n} of {total}',
        'del.submitting'                : 'Deleting…',
        'del.btn_confirm'               : 'Delete permanently',

        'del.sum.partitions'            : '{n} score',
        'del.sum.partitions.plural'     : '{n} scores',
        'del.sum.public'                : '{n} public',
        'del.sum.public.plural'         : '{n} public',
        'del.sum.private'               : '{n} private',
        'del.sum.private.plural'        : '{n} private',
        'del.sum.groups'                : '{n} group',
        'del.sum.groups.plural'         : '{n} groups',
        'del.sum.subscription'          : 'Active {plan} subscription',
        'del.sum.engagement'            : 'committed until {date}',
        'del.sum.none'                  : 'Nothing to decide: this account leaves no scores and no groups.',

        'del.part.lead'                 : 'You have {n} score(s): {pub} public and {priv} private.',

        'del.group.lead'                : '“{name}” — group {i} of {total}, {n} people served.',
        'del.group.choose'              : 'Choose a member…',
        'del.ensemble'                  : 'Ensemble plan',
        'del.no_ensemble'               : 'no Ensemble plan',

        'del.sub.lead'                  : 'Your {plan} subscription is active.',
        'del.sub.engagement'            : 'Your commitment runs until {date}.',

        'del.err.choice'                : 'Pick an option to continue.',
        'del.err.email'                 : 'Enter the recipient account email.',
        'del.err.fallback'              : 'Say what should happen if the offer is declined.',
        'del.err.heir'                  : 'Choose the member to hand the group over to.',
        'del.err.ack'                   : 'Tick the box to continue.',
        'del.err.password'              : 'Enter your password.',

        'del.recap.partitions.keep_public' : 'Scores: public ones stay online, private ones are deleted.',
        'del.recap.partitions.bequeath'    : 'Scores: offered to {email}.',
        'del.recap.partitions.delete'      : 'Scores: all deleted, files included.',
        'del.recap.fallback.keep_public'   : 'If declined: public ones stay online, private ones are deleted.',
        'del.recap.fallback.delete'        : 'If declined: everything is deleted.',
        'del.recap.group.bequeath'         : '{group}: offered to {name}.',
        'del.recap.group.delete'           : '{group}: deleted.',
        'del.recap.groups_empty'           : '{n} group with no member: deleted.',
        'del.recap.groups_empty.plural'    : '{n} groups with no members: deleted.',
        'del.recap.subscription'           : 'Subscription: cancelled immediately, no refund.',
        'del.recap.reason'                 : 'Reason: {reason}',
        'del.recap.no_reason'              : 'Reason: not given.',
    },
};

// ── Langue active ─────────────────────────────────────────────────────────────
const _supportedLangs = (typeof window !== 'undefined' && window.__SUPPORTED_LANGS__) || ['fr', 'en'];
const _defaultLang    = (typeof window !== 'undefined' && window.__DEFAULT_LANG__)    || 'fr';
const _rawLang        = (typeof window !== 'undefined' && window.__LANG__)            || _defaultLang;
const _lang           = _supportedLangs.includes(_rawLang) ? _rawLang : _defaultLang;

/**
 * Retourne la traduction d'une clé.
 * Interpolation : {variable} remplacé par params[variable].
 * Pluriel : si params.n > 1 et que la clé .plural existe, elle est utilisée.
 */
export function t(key, params = {}) {
    const dict = _translations[_lang] ?? _translations.fr;

    let resolvedKey = key;
    if ('n' in params && params.n > 1 && (key + '.plural') in dict) {
        resolvedKey = key + '.plural';
    }

    let str = dict[resolvedKey] ?? dict[key] ?? key;

    for (const [k, v] of Object.entries(params)) {
        str = str.replaceAll('{' + k + '}', String(v ?? ''));
    }

    return str;
}

/** Retourne la langue active : 'fr' | 'en' */
export function lang() { return _lang; }